import React from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import TournamentLowBalanceMessage from './TournamentLowBalanceMessage';
import classNames from 'classnames';

const fppRate = 100

const TournamentServerMessageDialog = ({ t, message, onClose, error, onDeposit, data, payWithFPP }) => {
  const BTN_NAMES = {
    confirm: t('ok')
  };

  const isErrorLowBalance = message === 'Low balance';
  const { currency, buyin, fee } = data.buyIn;
  const buyinFPP = (buyin + fee) * fppRate;


  const tournamentServerMessageDialogClasses = classNames({
    'tournaments__popup': true,
    'tournaments__dialog-message': true,
    'tournament__lowBalance': isErrorLowBalance
  })
  return (
    <div className={tournamentServerMessageDialogClasses}>
      <div className="tournaments__popup__overlay tournaments__dialog-message__overlay" onClick={onClose} />
      <PopUpDialogTemplate
        title={isErrorLowBalance ? t('registrationError') : "Server message"}
        onClose={onClose}
        onConfirm={!isErrorLowBalance && onClose}
        text={isErrorLowBalance ? <TournamentLowBalanceMessage 
            onDeposit={onDeposit} 
            onClose={onClose} 
            message={t('insufficientBalance')}
            data={{currency, buyin, payWithFPP, buyinFPP}}
            t={t}
            /> : message}
        btnNames={!isErrorLowBalance && BTN_NAMES}
        errorHeader={error}
      />
      
    </div>
  );
}

export default TournamentServerMessageDialog;